<template>
  <div class="card" v-if="entity">
    <div class="entity-settings">
      <vs-button v-if="!edit" class="button" @click="edit = !edit">Editar</vs-button>
      <!-- <vs-button v-if="!edit" class="button" @click="edit = !edit">{{ edit ? 'Ver' : 'Editar' }}</vs-button> -->
      <EditEntity @emitCancel="cancelEdit" @updated="successUpdate" v-if="edit" :entity="entity" />
      <ShowEntity v-else :entity="entity" />
    </div>
  </div>
</template>

<script>
import EditEntity from './EditEntity'
import ShowEntity from './ShowEntity'
import { mapState } from 'vuex'
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'

const organizationDetail = gql`
  query organizationDetail($currentUserToken: String, $organizationId: Int) {
    organizationDetail(currentUserToken: $currentUserToken, organizationId: $organizationId) {
      businessName
      showInRanking
      city
      comments
      commercialAddress
      country
      cuit
      email
      id
      incomeTaxSituation
      ivaSituation
      logo
      phone
      state
      productionMothers
      slaughterQuantityPerMonth
      ruca
      notificationEmails
      zipcode
      users {
        canBuy
        canSell
        createdAt
        cuil
        currentTime
        dni
        email
        establishmentRole
        firstname
        id
        lastname
        offerRole
        organizationId
        passport
        phone
      }
      establishments {
        active
        activity
        city
        cuig
        id
        marketRole
        name
        number
        renspa
        ruca
        state
        zipcode
      }
    }
  }
`

export default {
  name: 'settings-entity-tab',
  components: {
    EditEntity,
    ShowEntity
  },
  data () {
    return {
      edit: false,
      entity: {}
    }
  },
  beforeMount () {
    if (this.currentUser) {
      this.getEntity()
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    })
  },
  watch: {
    currentUser (newValue, oldValue) {
      this.entity = this.currentUser.organization
    }
  },
  methods: {
    successUpdate() {
      this.edit = false
      this.getEntity()
    },
    cancelEdit() {
      this.edit = false
    },
    getEntity() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(organizationDetail),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN')
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.entity = res.data.data.organizationDetail
        }
      })
    }
  }
}
</script>
